export enum KycProviders {
    FRANKIEONE = 'FRANKIEONE',
    SWIFTID = 'SWIFTID',
}
